import { Value } from '@philips-emr/tws-core';
import { Validation } from '@philips-emr/tws-core/lib/services/model-service';

const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

function validate(value: Value): Validation[] {
  let valid;

  if (value) {
    valid = Boolean((value as string).match(EMAIL));
  } else {
    valid = true;
  }

  return [{
    message: !valid ? 'beneficiary.informe-email-valido' : '',
    name: 'email-validator',
    valid,
  }];
}

export { validate as EmailValidator };
